import _regeneratorRuntime from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { WebPlugin } from '@capacitor/core';
export var ClipboardWeb =
/*#__PURE__*/
function (_WebPlugin) {
  _inherits(ClipboardWeb, _WebPlugin);

  function ClipboardWeb() {
    _classCallCheck(this, ClipboardWeb);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardWeb).apply(this, arguments));
  }

  _createClass(ClipboardWeb, [{
    key: "write",
    value: function () {
      var _write = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(options) {
        var blob, clipboardItemInput;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof navigator === 'undefined' || !navigator.clipboard)) {
                  _context.next = 2;
                  break;
                }

                throw this.unavailable('Clipboard API not available in this browser');

              case 2:
                if (!(options.string !== undefined)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return this.writeText(options.string);

              case 5:
                _context.next = 34;
                break;

              case 7:
                if (!options.url) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return this.writeText(options.url);

              case 10:
                _context.next = 34;
                break;

              case 12:
                if (!options.image) {
                  _context.next = 33;
                  break;
                }

                if (!(typeof ClipboardItem !== 'undefined')) {
                  _context.next = 30;
                  break;
                }

                _context.prev = 14;
                _context.next = 17;
                return fetch(options.image);

              case 17:
                _context.next = 19;
                return _context.sent.blob();

              case 19:
                blob = _context.sent;
                clipboardItemInput = new ClipboardItem(_defineProperty({}, blob.type, blob));
                _context.next = 23;
                return navigator.clipboard.write([clipboardItemInput]);

              case 23:
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](14);
                throw new Error('Failed to write image');

              case 28:
                _context.next = 31;
                break;

              case 30:
                throw this.unavailable('Writing images to the clipboard is not supported in this browser');

              case 31:
                _context.next = 34;
                break;

              case 33:
                throw new Error('Nothing to write');

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[14, 25]]);
      }));

      function write(_x) {
        return _write.apply(this, arguments);
      }

      return write;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var clipboardItems, type, clipboardBlob, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof navigator === 'undefined' || !navigator.clipboard)) {
                  _context2.next = 2;
                  break;
                }

                throw this.unavailable('Clipboard API not available in this browser');

              case 2:
                if (!(typeof ClipboardItem !== 'undefined')) {
                  _context2.next = 22;
                  break;
                }

                _context2.prev = 3;
                _context2.next = 6;
                return navigator.clipboard.read();

              case 6:
                clipboardItems = _context2.sent;
                type = clipboardItems[0].types[0];
                _context2.next = 10;
                return clipboardItems[0].getType(type);

              case 10:
                clipboardBlob = _context2.sent;
                _context2.next = 13;
                return this._getBlobData(clipboardBlob, type);

              case 13:
                data = _context2.sent;
                return _context2.abrupt("return", {
                  value: data,
                  type: type
                });

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](3);
                return _context2.abrupt("return", this.readText());

              case 20:
                _context2.next = 23;
                break;

              case 22:
                return _context2.abrupt("return", this.readText());

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 17]]);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "readText",
    value: function () {
      var _readText = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var text;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.readText)) {
                  _context3.next = 2;
                  break;
                }

                throw this.unavailable('Reading from clipboard not supported in this browser');

              case 2:
                _context3.next = 4;
                return navigator.clipboard.readText();

              case 4:
                text = _context3.sent;
                return _context3.abrupt("return", {
                  value: text,
                  type: 'text/plain'
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function readText() {
        return _readText.apply(this, arguments);
      }

      return readText;
    }()
  }, {
    key: "writeText",
    value: function () {
      var _writeText = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(text) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.writeText)) {
                  _context4.next = 2;
                  break;
                }

                throw this.unavailable('Writting to clipboard not supported in this browser');

              case 2:
                _context4.next = 4;
                return navigator.clipboard.writeText(text);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function writeText(_x2) {
        return _writeText.apply(this, arguments);
      }

      return writeText;
    }()
  }, {
    key: "_getBlobData",
    value: function _getBlobData(clipboardBlob, type) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        if (type.includes('image')) {
          reader.readAsDataURL(clipboardBlob);
        } else {
          reader.readAsText(clipboardBlob);
        }

        reader.onloadend = function () {
          var r = reader.result;
          resolve(r);
        };

        reader.onerror = function (e) {
          reject(e);
        };
      });
    }
  }]);

  return ClipboardWeb;
}(WebPlugin);